/* eslint-disable no-inner-declarations */
import color from "./color";
import timelineFunctions from "./timelineFunctions";

let graphic;
let unitHeight;
let timelineCanvas;
let clickCallback;

function drawTimeline(data, canvas, onClick) {
  graphic = [[]];
  unitHeight = 0;
  timelineCanvas = canvas;
  clickCallback = onClick;
  const ctx = timelineCanvas.getContext("2d");

  ctx.canvas.width = timelineCanvas.offsetWidth;
  ctx.canvas.height = timelineCanvas.offsetHeight;
  timelineCanvas.addEventListener("click", handleClick);

  const era_startDate = new Date(
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "year",
      "start",
      "earliest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "month",
      "start",
      "earliest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "day",
      "start",
      "earliest",
    ),
  );
  const era_endDate = new Date(
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "year",
      "end",
      "latest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "month",
      "end",
      "latest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "day",
      "end",
      "latest",
    ),
  );
  unitHeight =
    timelineCanvas.offsetHeight /
    ((timelineFunctions.monthDiff(era_startDate, era_endDate) / 12) * 4);

  const nodes = [];
  const firstNodeEndDate_month =
    timelineFunctions.extractFromDate(data[0], "month", "start", "earliest") < 10
      ? "0" + timelineFunctions.extractFromDate(data[0], "month", "start", "earliest")
      : timelineFunctions.extractFromDate(data[0], "month", "start", "earliest");
  const firstNodeEndDate_day =
    timelineFunctions.extractFromDate(data[0], "day", "start", "earliest") < 10
      ? "0" + timelineFunctions.extractFromDate(data[0], "day", "start", "earliest") - 1
      : timelineFunctions.extractFromDate(data[0], "day", "start", "earliest") - 1;
  const firstNodeEndDate =
    timelineFunctions.extractFromDate(data[0], "year", "start", "earliest") +
    "-" +
    firstNodeEndDate_month +
    "-" +
    firstNodeEndDate_day;
  nodes.push({
    start_earliest: timelineFunctions.customNode_entireEra.start_earliest,
    end_latest: firstNodeEndDate,
  });
  let lastIndex;
  data.forEach((node, index) => {
    if (node.id && node.location) {
      nodes.push(node);
      lastIndex = index;
    }
  });
  nodes.push({
    start_earliest: data[lastIndex].end_latest,
    end_latest: timelineFunctions.customNode_entireEra.end_latest,
  });

  Date.prototype.addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };

  let d = 0;
  for (
    let r = 0;
    r < (timelineFunctions.monthDiff(era_startDate, era_endDate) / 12) * 4;
    r++
  ) {
    for (let i = 0; i < 92; i++) {
      if (
        era_startDate.addDays(d).getDate() == 1 &&
        era_startDate.addDays(d).getMonth() % 3 == 0 &&
        i != 0
      ) {
        continue;
      } else {
        graphic[r].push({ date: era_startDate.addDays(d) });
        d++;
      }
    }
    graphic.push([]);
  }

  //MAIN FUNCTION
  nodes.forEach((currentNode, index) => {
    const startDate = new Date(
      timelineFunctions.extractFromDate(currentNode, "year", "start", "earliest"),
      timelineFunctions.extractFromDate(currentNode, "month", "start", "earliest") - 1,
      timelineFunctions.extractFromDate(currentNode, "day", "start", "earliest"),
    );

    const duration = Math.abs(
      timelineFunctions.getPeriodLength(
        timelineFunctions.getSplitDate(currentNode.start_earliest),
        timelineFunctions.getSplitDate(currentNode.end_latest),
      ),
    );

    for (let d = 0; d < duration; d++) {
      const monthsBetween = timelineFunctions.monthDiff(
        era_startDate,
        startDate.addDays(d),
      );
      const startMonthOfNode = monthsBetween % 12; //calculates the number of the month that the currentNode starts in (0 for january)
      const additionalQuarters = Math.floor((startMonthOfNode + 1) / 3); //calculates the number of quarters that ended before startMonthOfNode
      const cursor_row = (monthsBetween - startMonthOfNode) / 3 + additionalQuarters; //calculates the row / y-axis position (index of outer array of "graphic")
      const cursor_unit =
        timelineFunctions.getPreviousMonthsLength(
          startDate.addDays(d).getMonth() + 1,
          startDate.addDays(d).getFullYear(),
        ) +
        startDate.addDays(d).getDate() -
        1;

      let unitColor = 0;
      if (0 < index && index < nodes.length - 1) {
        const locationColor = color.getLocationColor(
          currentNode.location.latitude,
          currentNode.location.longitude,
        );
        unitColor = {
          hue: locationColor.h,
          saturation: locationColor.s,
          lightness: locationColor.l,
        };
      }

      if (!graphic[cursor_row]) return;

      graphic[cursor_row][cursor_unit] = {
        date: startDate.addDays(d),
        color: unitColor,
        index: index,
      };
    }
  });

  //clean canvas
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

  graphic.forEach((row, rowIndex) => {
    row.forEach((item, itemIndex) => {
      if (item.color) {
        if (item.color != 0) {
          ctx.fillStyle = `hsl(${item.color.hue}, ${item.color.saturation}%, ${item.color.lightness}%)`;
        } else ctx.fillStyle = "black";
        ctx.fillRect(itemIndex, rowIndex * unitHeight, 1, Math.ceil(unitHeight));
      }
    });
  });
}

function handleClick(event) {
  const y = Math.round(event.offsetY / unitHeight) - 1;
  const x = Math.round(event.offsetX);

  if (0 <= x && x < graphic[y].length) {
    const block = graphic[y][x];

    if (block) clickCallback(block.date);
  }
}

function remove() {
  timelineCanvas.removeEventListener("click", handleClick);
}

export default {
  drawTimeline,
  handleClick,
  remove,
};
